import "./configDetGrid.scss";
import React, { useEffect, useMemo, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MenuItem, Select, TextField } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { MdCheck, MdClear, MdClose } from "react-icons/md";
import Grid from "@mui/material/Grid";
import { LuFilterX } from "react-icons/lu";
//import { ExcelDataType } from 'ag-grid-community';
import "@ag-grid-community/core/dist/styles/ag-grid.css";
import "@ag-grid-community/core/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import customGroupCellRenderer from "./customGroupCellRenderer";
import * as XLSX from "xlsx";
import StyledTooltip from "../shared/toolTip/StyledTooltip";
import CustomTooltip from "../userProjects/customTooltip";
//import { fmodelbreakAct } from "../redux/project/projActions";
import { fModelBreakMulAct } from "../redux/project/projActions";
//import { getModelBreak } from "../apis/pgapis";
import { showLoader } from "../redux/ctrl/ctrlActions";
import { FiUpload } from "react-icons/fi";
import Button from '@mui/material/Button';
import Popover from '@mui/material/Popover';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import { agGridTrans } from "../translation/i18n";
import { tagStatusActions } from "../redux/ctrl/vals";
import { useTranslation } from 'react-i18next';
import RelatedTagModal from "../tags/RelatedTagModal";
import { statusBar } from "../../utils";

const ConfigDetGrid = () => {
  const dispatch = useDispatch();
  const gridRef = useRef(null);
  const tagGridRef = React.useRef(null);
  const configDetGridRef = React.useRef(null);
  const [gridApi, setGridApi] = useState();
  const [rowData, setRowData] = useState([]);
  //const modelBreak = useSelector((state) => state?.project?.getModelBreak);
  const modelBreakMulti = useSelector((state) => state?.project?.getModelBreakMul.data);

  const tagdata = useSelector((state) => state.prjasn.projectsAsn);
  const tags = useSelector((state) => state.project.tags);
  const selectedTag = useSelector((state) => state.ctrl.tags);
  const commercialTypes = useSelector((state) => state.ctrl.commercialTypes);
  const wsTabValue = useSelector((state) => state.ctrl.wsTabValue);
  const isInstrumentationTab = wsTabValue === "Instrumentation" ? true : false;
  const [isRelTagModalOpen, setIsRelTagModalOpen] = useState(false);
  const [relTagData, setRelTagData] = useState([]);


  const [modelData, setModelData] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const { t, i18n } = useTranslation();
  const [tag, setTag] = useState([]);
  let ctrlState = useSelector((state) => state.ctrl);
  const maxDisplayedTags = 3;
  const tagsPerRow = 5;

  useEffect(() => {
    if (modelBreakMulti) {
      const uniqueModels = modelBreakMulti;

      setModelData(uniqueModels);
      setRowData(splitRowData1(uniqueModels));
      //setModelData(data1);
    }
  }, [modelBreakMulti]);

  const MultiLineDescriptionRenderer = ({ value }) => {
    const lines = value?.split("\n");
    return (
      <>
        {lines?.map((line, index) => (
          <div key={index}>{line}</div>
        ))}
      </>
    );
  };
  const handleClosePopup = () => {
    setOpenPopup(false);
  };
  //  clear filter
  const clearFilters = () => {
    if (gridRef) {
      gridRef.current.api.setFilterModel(null);
    }
  };

  const tagNumberCellRenderer = (params) => {
    // console.log("tagNumberCellRenderer");

    const tagClickHandler = () => {
      const rowData = params.data;
      let tag = rowData.tag;
      if (typeof tag === 'string') {
        tag = tag.split(',').map(item => item.trim());
      }
      if (Array.isArray(tag)) {
        setTag(tag);
        setOpenPopup(true);
        // console.log("clicked");
        //console.log({ openPopup });
      }
    };

    let tagNumbers;
    if (Array.isArray(params.value)) {
      tagNumbers = params.value.join(", ");
      if (params.value.length > maxDisplayedTags) {
        tagNumbers = params.value.slice(0, maxDisplayedTags).join(", ") + "...";
      }
    } else if (typeof params.value === 'string') {
      let tags = params.value.split(',').map(item => item.trim());
      tagNumbers = tags.join(", ");
      if (tags.length > maxDisplayedTags) {
        tagNumbers = tags.slice(0, maxDisplayedTags).join(", ") + "...";
      }
    }
    //console.log("params.value", params.value);

    // Check and handle if params.value is an array and exceeds maxDisplayedTags
    if (Array.isArray(params.value) && params.value.length > maxDisplayedTags) {
      tagNumbers = params.value.slice(0, maxDisplayedTags).join(", ") + "..."; // Display ellipsis when tags exceed maxDisplayedTags
      // console.log("tagNumbers after slicing:", tagNumbers);
    }


    return (
      <div style={{ cursor: "pointer" }} onClick={tagClickHandler}>
        {tagNumbers}  {/* Default message if params.value is undefined */}
      </div>
    );
  };


  // const tagNumberCellRenderer = (params) => {


  //   const tagClickHandler = () => {
  //     const rowData = params.data;
  //     let tag = rowData.tag;
  //     if (typeof tag === 'string') {
  //       tag = tag.split(',').map(item => item.trim());
  //     }
  //     if (Array.isArray(tag)) {
  //       setTag(tag);
  //       setOpenPopup(true);


  //     }
  //   };

  //   let tagNumbers = Array.isArray(params.value) ? params.value.join(", ") : params.value;

  //   if (Array.isArray(params.value) && params.value.length > maxDisplayedTags) {
  //     tagNumbers = params.value.slice(0, maxDisplayedTags).join(",") + "..."; // Display ellipsis when tags exceed maxDisplayedTags


  //   }

  //   return (
  //     <div style={{ cursor: "pointer" }} onClick={tagClickHandler}>
  //       {tagNumbers}
  //     </div>
  //   );
  // };

  const mapPricesToModels = () => {
    const priceMappings = [];

    for (let i = 0; i < selectedTag.length; i++) {
      const tag = selectedTag[i];
      for (let j = 1; j <= 6; j++) {
        const priceKey = `pur_unit_list_price${j}`;
        const sellPriceKey = `pur_sell_list_price${j}`;
        const modelKey = `pur_mod_num_part${j}`;
        const price = tag[priceKey];
        const sellPrice = tag[sellPriceKey];
        const model = tag[modelKey];

        if (price !== null || sellPrice !== null) {
          priceMappings.push({ model, price, sellPrice });
        }
      }
    }


    return priceMappings;
  };




  function getPriceForModel(model, modelNameAndPriceMapping) {


    if (!model) {
      return null;
    }

    for (let i = 0; i < modelNameAndPriceMapping.length; i++) {
      if (modelNameAndPriceMapping[i].model === model) {

        return modelNameAndPriceMapping[i].price;
      }
    }


    return null;
  }

  function getSellPriceForModel(model, modelNameAndPriceMapping) {
    if (!model) {
      return null;
    }

    for (let i = 0; i < modelNameAndPriceMapping.length; i++) {
      if (modelNameAndPriceMapping[i].model === model) {
        return modelNameAndPriceMapping[i].sellPrice;
      }
    }

    return null;
  }


  function filterUniqueModels(modelData) {

    if (Array.isArray(modelData)) {
      const uniqueModels = modelData.reduce((acc, current) => {


        const found = acc.some(
          (item) => {

            return item.mName === current.mName;
          }
        );
        if (!found) {

          acc.push(current);
        }
        return acc;
      }, []);
      return uniqueModels;
    } else {

    }
  }
  const groupTagsIntoRows = (tags) => {
    const rows = [];
    for (let i = 0; i < tags.length; i += tagsPerRow) {
      rows.push(tags.slice(i, i + tagsPerRow));
    }
    return rows;
  };


  // const splitRowData1 = (uniqueModels) => {
  //     let rowDatas = [];

  //     let modelTagsMap = {}; 

  //     if (uniqueModels && uniqueModels.length > 0) {
  //         const modelNameAndPriceMapping = mapPricesToModels();

  //         for (let i = 0; i < uniqueModels.length; i++) {
  //             const modelItem = uniqueModels[i];

  //             let modelStr = modelItem.mstr;
  //             let tag_number= modelItem.tagNumber;
  //             if (!modelStr && modelItem.cModels && modelItem.cModels.length > 0) {
  //                 modelStr = modelItem.cModels[0].cModelStr; 
  //             }



  //         const parts = ['pur_mod_num_part1','pur_mod_num_part2','pur_mod_num_part3','pur_mod_num_part4','pur_mod_num_part5','pur_mod_num_part6']
  //          //1. Create a model string array of tag from tag grid  
  //             const modelString = selectedTag.reduce((acc, tag) => {
  //               const key = `${tag.tag_id}-${tag.tag_number}`;
  //             acc[tag.tag_number] = parts.map(part => tag[part]).filter(value => value && value.trim() !== '');
  //             return acc;
  //           }, {});


  //          //2.create model string array of model breakdown for each tag id 


  //          const modelStrings1 = modelBreakMulti.reduce((acc, item) => {
  //           if (!acc[item.tagId]) {
  //             acc[item.tagId] = [];
  //           }
  //           acc[item.tagId].push(...item.cModels.map(model => model.cModelStr));
  //           return acc;
  //         }, {});


  //        function findMatchingTags(modelString) {
  //             const keys = Object.keys(modelString);
  //             const valueToTags = {};

  //             keys.forEach(key => {
  //                 const values = modelString[key].sort().join(',');
  //                 if (!valueToTags[values]) {
  //                     valueToTags[values] = [];
  //                 }
  //                 valueToTags[values].push(key);
  //             });

  //             const result = Object.values(valueToTags);

  //             return result;
  //         }



  //          const matchingTags1 = findMatchingTags(modelString);




  //       // MS080AR1THACA3M0N5D1Q4Q8CR
  //       // 8782AW1A1N5M4B6D1Q4
  //       // MS080AR1THACA3M0N5D1Q4Q8CR
  //       // [MS080AR1THACA3M0N5D1Q4Q8CR,8782AW1A1N5M4B6D1Q4]
  //             // const matchingTags = selectedTag.filter(tag => {                   

  //             //                 if (modelStr) { 

  //             //                     return (
  //             //                         tag.pur_mod_num_part1 === modelStr ||      
  //             //                         tag.pur_mod_num_part2 === modelStr ||     
  //             //                         tag.pur_mod_num_part3 === modelStr ||
  //             //                         tag.pur_mod_num_part4 === modelStr ||
  //             //                         tag.pur_mod_num_part5 === modelStr ||
  //             //                         tag.pur_mod_num_part6 === modelStr
  //             //                     );
  //             //                 }
  //             //                 return false;
  //             //             })
  //            //1) create model string array of tag from tag grid
  //            //  2) create model string array of model breakdown for each tag id 
  //            //  3)


  //             // const match = matchingTags;




  //              //const tagNumbers = modelToTagsMap[modelStr.split(',').sort().join(',')] || [];
  //             // const tagNumbers = modelToTagsMap[modelStr.split(',').sort().join(',')] || [];
  //             const tagNumbers = [];
  //             // for (let tag in modelString) {
  //             //   modelString[tag]?.forEach((modelNum) => {
  //             //     if(modelNum === modelStr && !tagNumbers.includes(tag)){
  //             //       tagNumbers.push(tag);
  //             //     }
  //             //   })
  //             // }
  //             const modelToTagNumbers = {};

  // // selectedTag.forEach(tag => {
  // //   modelBreakMulti.forEach(model => {

  // //     if (String(tag.tag_id) === String(model.tagId)) {

  // //       const key = `${model.tagId}-${model.cModels[0].cModelStr}`;

  // //        if (!modelToTagNumbers[key]) {
  // //         modelToTagNumbers[key] = [];
  // //       }
  // //       modelToTagNumbers[key].push(tag.tag_number);

  // //     }
  // //   });
  // // });



  // // const tagNumbers = matchingTags.map(tag => tag.tag_number);

  // const price = getPriceForModel(modelStr, modelNameAndPriceMapping);
  // const previousTags = modelTagsMap[modelStr] || [];
  // const duplicateTags = tagNumbers.some(tag => previousTags.includes(tag));
  // // const skipSequence = sequenceNumber > 1 && duplicateTags; 
  // let searchElement = tag_number;
  // let tag_number1 = [];

  // matchingTags1.forEach(tags => {
  //     if (tags.includes(searchElement)) {
  //         tag_number1 = [...tag_number1, ...tags.filter(tag => tag !== searchElement)];
  //     }
  // });

  // tag_number = [searchElement, ...tag_number1].join(', ');
  // const count = tag_number.split(', ').length;


  // rowDatas.push({
  //                     // srNo: sequenceNumber,
  //                     tag: tag_number,
  //                     model: modelStr,
  //                     price: price,
  //                     count: count,
  //                 });

  //                 modelTagsMap[modelStr] = tagNumbers;

  //             // Increment sequence number if not skipping sequence
  //             // if (!skipSequence) {
  //             //     sequenceNumber++;
  //             // }

  //             if (modelItem.cModels) {
  //                 for (let j = 0; j < modelItem.cModels.length; j++) {
  //                     const subModelItem = modelItem.cModels[j];
  //                     rowDatas.push({
  //                                   code: modelItem.mName.substring(modelItem.mName.indexOf('-') + 1), 
  //                                   name:"Product Description",
  //                                   description: modelItem.mDescription, 
  //                                     });
  //                     if (subModelItem.cOptions) {
  //                         for (let k = 0; k < subModelItem.cOptions.length; k++) {
  //                             const option = subModelItem.cOptions[k];

  //                             rowDatas.push({
  //                                 code: option.optCode,
  //                                 name: option.optName,
  //                                 description: option.optDesc,
  //                             });
  //                         }
  //                     }
  //                 }
  //             } else if (modelItem.cOptions) {
  //                 for (let k = 0; k < modelItem.cOptions.length; k++) {
  //                     const option = modelItem.cOptions[k];

  //                     rowDatas.push({
  //                         code: option.optCode,
  //                         name: option.optName,
  //                         description: option.optDesc,
  //                     });
  //                 }
  //             }
  //         }
  //     }

  //     return rowDatas;
  // };


  const splitRowData1 = (uniqueModels) => {
    const rowDatas = [];
    const modelTagsMap = {};
    const parts = [
      "pur_mod_num_part1",
      "pur_mod_num_part2",
      "pur_mod_num_part3",
      "pur_mod_num_part4",
      "pur_mod_num_part5",
      "pur_mod_num_part6",
    ];

    if (!uniqueModels?.length) return rowDatas;

    const modelNameAndPriceMapping = mapPricesToModels();

    // Create model string mapping from tags
    const modelString = selectedTag.reduce((acc, tag) => {
      acc[tag.tag_number] = parts
        .map((part) => tag[part])
        .filter((value) => value?.trim());
      return acc;
    }, {});

    // Find matching tag groups
    const valueToTags = {};
    Object.entries(modelString).forEach(([key, values]) => {
      const sortedValues = values.sort().join(",");
      if (!valueToTags[sortedValues]) {
        valueToTags[sortedValues] = [];
      }
      valueToTags[sortedValues].push(key);
    });
    const matchingTags1 = Object.values(valueToTags);

    uniqueModels.forEach(modelItem => {
      let modelStr = modelItem.mstr;
      let tag_number = modelItem.tagNumber;

      if (!modelStr && modelItem.cModels?.[0]?.cModelStr) {
        modelStr = modelItem.cModels[0].cModelStr;
      }

      if (modelStr && tag_number) {
        let finalTagNumber = tag_number;
        let count = 1;
        let relTags = '';

        if (isInstrumentationTab) {
          let tag_number1 = [];
          matchingTags1.forEach(tags => {
            if (tags.includes(tag_number)) {
              tag_number1 = [...tag_number1, ...tags.filter(tag => tag !== tag_number)];
            }
          });

          finalTagNumber = [tag_number, ...tag_number1].join(", ");
          count = finalTagNumber.split(", ").length;
        } else {
          const originalTag = selectedTag.find(tag => tag.tag_number === finalTagNumber);
          count = originalTag?.quantity || 1;
          relTags = originalTag?.gen_rel_tag;
        }

        const price = getPriceForModel(modelStr, modelNameAndPriceMapping);
        const sellPrice = getSellPriceForModel(modelStr, modelNameAndPriceMapping);


        rowDatas.push({
          tag: finalTagNumber,
          model: modelStr,
          price: price,
          sellPrice: sellPrice,
          count: count,
          gen_rel_tag: relTags
        });

        modelTagsMap[modelStr] = isInstrumentationTab ? finalTagNumber.split(", ").filter(t => t !== tag_number) : [];

        // Add description rows
        if (modelItem.cModels) {
          modelItem.cModels.forEach(subModelItem => {
            let mName = modelItem.mName.substring(modelItem.mName.indexOf("-") + 1)
            if (subModelItem.cOptions[0] && subModelItem.cOptions[0].optCode !== mName) {
              rowDatas.push({
                code: mName,
                name: "Product Description",
                description: modelItem.mDescription
              });
            }

            if (subModelItem.cOptions) {
              subModelItem.cOptions.forEach(option => {
                rowDatas.push({
                  code: option.optCode,
                  name: option.optName,
                  description: option.optDesc
                });
              });
            }
          });
        } else if (modelItem.cOptions) {
          modelItem.cOptions.forEach(option => {
            rowDatas.push({
              code: option.optCode,
              name: option.optName,
              description: option.optDesc
            });
          });
        }
      }
    });
    return rowDatas;
  };


  function filterUniqueModels1(modelData) {
    //working 3/6

    if (Array.isArray(modelData)) {
      const uniqueModels = modelData.reduce((acc, current) => {

        const found = acc.some((group) => {
          for (let i = 1; i <= 6; i++) {


            if (group[`pur_mod_num_part${i}`] !== current[`pur_mod_num_part${i}`]) {




              return false;
            }
          }
          return true;
        });

        if (!found) {
          acc.push(current);
        } else {

        }
        return acc;
      }, []);




      return uniqueModels;
    } else {
      return [];
    }
  }

  function filterUniqueModels2(modelData) {
    if (Array.isArray(modelData)) {
      const modelStrings = modelData.map(model => {
        let modelString = '';
        for (let i = 1; i <= 6; i++) {
          if (model[`pur_mod_num_part${i}`]) {
            modelString += model[`pur_mod_num_part${i}`];
          }
        }

        return modelString;
      });

      const uniqueModelStrings = [...new Set(modelStrings)];

      const uniqueModels = uniqueModelStrings.map(uniqueModelString => {
        return modelData.find(model => {
          let modelString = '';
          for (let i = 1; i <= 6; i++) {
            if (model[`pur_mod_num_part${i}`]) {
              modelString += model[`pur_mod_num_part${i}`];
            }
          }
          return modelString === uniqueModelString;

        });
      });

      return uniqueModels;
    } else {
      return [];
    }
  }

  useEffect(() => {
    if (ctrlState.tags?.length > 0) {
      // Filter unique models based on pur_mod_num_part values
      let uniqueTags = []
      if (isInstrumentationTab) {
        uniqueTags = filterUniqueModels2(ctrlState.tags);
      } else {
        uniqueTags = ctrlState.tags;
      }

      // Construct the payload
      const payload = {};
      uniqueTags.forEach((tag) => {
        if (!payload[tag.gen_technology_type]) {
          payload[tag.gen_technology_type] = [];
        }
        payload[tag.gen_technology_type].push(tag.tag_id);
      });

      // Dispatch the action with the constructed payload
      dispatch(fModelBreakMulAct(payload));
    }
  }, [ctrlState.tags]);

  const selectData = () => {
    let selectedNodes = gridApi.getSelectedNodes();
    let selectedData = selectedNodes.map((node) => node.data);


  };

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const gridoptions = {
    defaultColDef: {
      flex: 1,
      minWidth: 150,
      resizable: true,
      cellStyle: { whiteSpace: "pre-line" },
    },
  };

  const onCellClicked = (params) => {
    if (params.colDef.field === 'gen_rel_tag' && params.value) {
      setRelTagData(params.value.split(','))
      setIsRelTagModalOpen(true)
    }
  }

  const renderRelatedTag = (params) => {
    // return params.data.gen_rel_tag
    if (!params.data.gen_rel_tag) return null

    const tagIds = params.data.gen_rel_tag.split(',')
    const tagNumbers = tagIds.map((tagId) => {
      const tag = tags.find((tag) => tag.tag_id == tagId)
      return tag.tag_number
    })
    return tagNumbers.join(',')
  }

  const columnDefs = useMemo(
    () => [

      { headerName: wsTabValue === 'Documents & Order Services' ? 'Item Number' : t('Tag Number'), field: "tag", maxWidth: 200, cellRenderer: tagNumberCellRenderer },
      {
        headerName: t('Related Tag'), hide: isInstrumentationTab, field: "gen_rel_tag", maxWidth: 200, cellStyle: { cursor: 'pointer' },
        valueGetter: renderRelatedTag,
      },
      { headerName: t('Qty'), field: "count", maxWidth: 100 },
      { headerName: t('Model Number'), field: "model" },
      { headerName: t('Code'), field: "code", maxWidth: 110, cellClass: 'stringType' },
      { headerName: t('Name'), field: "name" },

      {
        headerName: t('Description'),
        field: "description",
        //cellRenderer: MultiLineDescriptionRenderer,
        // editable: true,
        // cellClass: "column-with-ellipsis",
      },
      { headerName: t('Unit Price'), field: "price", maxWidth: 120 },
      { headerName: t('Sell Price'), field: "sellPrice", maxWidth: 120 },

    ],
    []
  );


  const autoGroupColumnDef = useMemo(() => {
    return {
      cellRenderer: customGroupCellRenderer,
    };
  }, []);

  const defaultColDef = useMemo(
    () => ({
      resizable: true,
      sortable: true,
      flex: 1,
      filter: true,
      minWidth: 120,
      //wrapText: true,
      // autoHeight: true,
      sortingOrder: ["asc", "desc", " "],
      filterParams: {
        buttons: ["apply", "cancel"],
        closeOnApply: true,
      },
      menuTabs: ["filterMenuTab", "generalMenuTab", "columnsMenuTab"],
      tooltipComponent: CustomTooltip,
    }),
    []
  );

  const excelStyles = useMemo(() => {
    return [
      {
        id: "cell",
        alignment: {
          horizontal: "Center",
          vertical: "Center",
        },

        borders: {
          borderBottom: {
            lineStyle: "Dot",
            weight: 1,
          },
          borderRight: {
            lineStyle: "Dot",
            weight: 1,
          },
          borderLeft: {
            lineStyle: "Dot",
            weight: 1,
          },
        },
      },
      {
        id: "stringType",
        dataType: "String",
      },
      {
        id: "header",
        alignment: {
          horizontal: "Center",
          vertical: "Center",
        },
        font: {
          //fontName: 'Calibri Light',
          color: "#ffffff",
          bold: true,
        },
        interior: {
          color: "#000000",
          pattern: "Solid",
        },
        borders: {
          borderTop: {
            color: "#ffffff",
            lineStyle: "Continuous",
            weight: 1,
          },
          borderBottom: {
            color: "#ffffff",
            lineStyle: "Continuous",
            weight: 1,
          },
          borderLeft: {
            color: "#ffffff",
            lineStyle: "Continuous",
            weight: 1,
          },
          borderRight: {
            color: "#ffffff",
            lineStyle: "Continuous",
            weight: 1,
          },
        },
      },
      {
        id: "topHeader",
        alignment: {
          horizontal: "Center",
          vertical: "Center",
        },
        font: {
          //fontName: 'Calibri Light',
          color: "#000000",
          bold: true,
          size: 24,
        },
        interior: {
          color: "#ffffff",
          pattern: "Solid",
        },
      },
      {
        id: "secHeader",
        alignment: {
          horizontal: "Center",
          vertical: "Center",
        },
        font: {
          //fontName: 'Calibri Light',
          color: "#ffffff",
          bold: true,
          size: 18,
        },
        interior: {
          color: "#000000",
          pattern: "Solid",
        },
        borders: {
          borderLeft: {
            color: "#ffffff",
            lineStyle: "Continuous",
            weight: 1,
          },
          borderRight: {
            color: "#ffffff",
            lineStyle: "Continuous",
            weight: 1,
          },
        },
      },
    ];
  }, []);
  const onBtExport = () => {
    if (gridRef.current) {
      const params = {
        fileName: "modelstringdata.xlsx",
        excelStyles: excelStyles,
        // excelDataType: ExcelDataType.String,
      };
      gridRef.current.api.exportDataAsExcel(params);
    }
  };

  return (
    <>
      {/* <Grid container>
          <Grid item style={{ height: "50%", marginLeft: "1%", marginRight: "50%" }}  > */}

      <Grid className="export">
        <div>
          <StyledTooltip
            title={t("Clear Filters")}
            placement="bottom"
            disableInteractive
          >
            <label>
              <LuFilterX
                className="tag-grid-head-cntrl mx-2"
                onClick={clearFilters}
                style={{ cursor: "pointer" }}
              />
            </label>
          </StyledTooltip>
          <StyledTooltip
            title={t("Export")}
            placement="bottom"
            disableInteractive
          >
            <label>
              <FiUpload
                className="tag-grid-head-cntrl mx-2"
                onClick={onBtExport}
                style={{ cursor: "pointer" }}
              />
            </label>
          </StyledTooltip>
        </div>
      </Grid>
      {/* <StyledTooltip title='Export' placement="bottom" disableInteractive> <label><FiUpload onClick={onBtExport} /> </label>  </StyledTooltip> */}

      <div
        id="inputgrid"
        /*style={{height:"28rem", width:"110%"}} */ className="ag-theme-alpine tagTreeG"
      >
        <Grid container className="marginRow px-2 tags-main" spacing={1}>
          <Grid item md={12} sm={12} xs={12} className="gridHdr">
            <Grid container className="align-items-center " spacing={1}>
              <Grid item md={12} sm={12} xs={12}>
                {/* <div style={{ height: "71vh" }}> */}
                <div className="gridHeightConfigDetail">
                  {" "}
                  <AgGridReact
                    statusBar={statusBar}
                    groupHeaderHeight={25}
                    headerHeight={25}
                    rowData={rowData}
                    localeText={agGridTrans[localStorage.getItem("lang")]}
                    excelStyles={excelStyles}
                    ref={gridRef}
                    gridoptions={gridoptions}
                    columnDefs={columnDefs}
                    tooltipComponent={CustomTooltip}
                    defaultColDef={defaultColDef}
                    rowHeight={26}
                    autoGroupColumnDef={autoGroupColumnDef}
                    rowSelection={"multiple"}
                    stopEditingWhenCellsLoseFocus={true}
                    enableRangeSelection={true}
                    suppressCopyRowsToClipboard={true}
                    onCellClicked={e => onCellClicked(e)}
                  />
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
      <Dialog
        open={openPopup}
        onClose={handleClosePopup}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle
          style={{
            fontFamily: "NotoSans-SemiBold",
            fontSize: "18px",
            padding: "10px 24px 5px 24px !important",
          }}
          className="model-title mb-0"
        >
          {t("All Tags")}
        </DialogTitle>
        <DialogContent>
          <div className="confirm-div">
            <span className="confirm-text">
              <Grid container direction="column" spacing={1}>
                {groupTagsIntoRows(tag).map((tagRow, index) => (
                  <Grid item container key={index} spacing={1}>
                    {tagRow.map((tag, index) => (
                      <Grid item key={index}>
                        {tag}
                      </Grid>
                    ))}
                  </Grid>
                ))}
              </Grid>
            </span>
          </div>
        </DialogContent>
        <DialogActions className="model-actions">
          <Button
            className="cnbtn btn cancel-btn"
            variant="outlined"
            onClick={handleClosePopup}
            color="primary"
          >
            {t("Close")}
          </Button>
        </DialogActions>
      </Dialog>
      <RelatedTagModal
        isRelTagModalOpen={isRelTagModalOpen}
        setIsRelTagModalOpen={setIsRelTagModalOpen}
        relTagData={relTagData}
      />
    </>
  );
};
export default ConfigDetGrid;